import React from 'react';
import { Box } from '@mui/material';
import logo from 'assets/images/app_logo.png';

const LogoMain = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', px: 1, py: 0.5 }}>
      <img
        src={logo}
        alt="App Logo"
        style={{
          maxHeight: '90px',
          maxWidth: '240px',
          width: '100%',
          objectFit: 'contain',
          display: 'block',
          margin: '0 auto'
        }}
      />
    </Box>
  );
};

export default LogoMain;
